/**
 * 时间管理工具类
 * 提供游戏时间相关的功能，包括帧时间、总时间、时间缩放等
 */
export class Time {
    /**
     * 使用外部引擎提供的deltaTime更新时间信息
     * @param deltaTime 外部引擎提供的帧时间间隔（秒）
     */
    static update(deltaTime) {
        // 设置未缩放的帧时间
        this.unscaledDeltaTime = deltaTime;
        this.deltaTime = deltaTime * this.timeScale;
        // 更新总时间
        this.unscaledTotalTime += this.unscaledDeltaTime;
        this.totalTime += this.deltaTime;
        // 更新帧数
        this.frameCount++;
    }
    /**
     * 场景改变时重置时间
     */
    static sceneChanged() {
        this.frameCount = 0;
        this.totalTime = 0;
        this.unscaledTotalTime = 0;
        this.deltaTime = 0;
        this.unscaledDeltaTime = 0;
    }
    /**
     * 检查指定的时间间隔是否已经过去
     * @param interval 时间间隔（秒）
     * @param lastTime 上次检查的时间
     * @returns 是否已经过去指定时间
     */
    static checkEvery(interval, lastTime) {
        return this.totalTime - lastTime >= interval;
    }
}
/**
 * 上一帧到当前帧的时间间隔（秒）
 */
Time.deltaTime = 0;
/**
 * 未缩放的帧时间间隔（秒）
 */
Time.unscaledDeltaTime = 0;
/**
 * 游戏开始以来的总时间（秒）
 */
Time.totalTime = 0;
/**
 * 未缩放的总时间（秒）
 */
Time.unscaledTotalTime = 0;
/**
 * 时间缩放比例
 */
Time.timeScale = 1;
/**
 * 当前帧数
 */
Time.frameCount = 0;
//# sourceMappingURL=Time.js.map